import { ApiResponse, fetchApi, PaginationRequest, PaginationResponse } from './common';

// 创建患者请求接口
export interface CreatePatientRequest {
  name: string;
  phone_number: string;
  gender?: string;
  birth_date?: string;
}

// 创建患者响应接口
export interface CreatePatientResponse {
  patient_id: string;
  name: string;
  gender?: string;
  birth_date?: string;
  create_time: string;
}

// 患者信息接口
export interface PatientInfo {
  id: string;
  name: string;
  gender?: string;
  birth_date?: string;
}

// 获取患者列表响应接口
export type ListPatientsResponse = PaginationResponse<PatientInfo>;

// 医生API请求函数
export const doctorApi = {
  // 创建患者
  createPatient: async (data: CreatePatientRequest): Promise<ApiResponse<CreatePatientResponse>> => 
    fetchApi<CreatePatientResponse>('/api/doctor_view/patients', 'POST', data),

  // 获取患者列表
  listPatients: async (params?: PaginationRequest): Promise<ApiResponse<ListPatientsResponse>> => {
    const url = new URL('/api/doctor_view/patients', window.location.origin);
    if (params) {
      Object.keys(params).forEach(key => {
        const value = params[key as keyof PaginationRequest];
        if (value !== undefined) {
          url.searchParams.append(key, value.toString());
        }
      });
    }
    return fetchApi<ListPatientsResponse>(url.toString(), 'GET');
  }
};